import { type ErrorComponentProps } from "@tanstack/react-router";

import styles from "./ErrorBoundary.module.css";
import { ErrorFallback } from "./ErrorFallback";

/**
 * `errorComponent` for routes nested under a route that already mounts a
 * `PageLayout` (e.g. children of `plantDetailRoute`): renders the same
 * fallback without a second `PageLayout` and without forcing `min-height:
 * 100vh`, so it fits inside the already-rendered frame's `<Outlet/>`.
 */
export const NestedRouteErrorComponent = (props: ErrorComponentProps) => (
  <div className={styles.nestedFallback}>
    <ErrorFallback {...props} />
  </div>
);
